import { NxMessageToastService } from '@allianz/ng-aquila/message';
import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { ToastMessageComponent } from '../components/toast-message/toast-message.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private readonly messageToastService = inject(NxMessageToastService);

  error: WritableSignal<HttpErrorResponse | null> = signal(null);

  httpErrorResponseToast(error: HttpErrorResponse) {
    this.error.set(error);
    console.error(error);

    switch (error?.status) {
      case 400:
        this.showMessage('Bad request. Please check the data sent and try again.');
        break;
      case 401:
        this.showMessage('Unauthorized. You do not have the necessary credentials to access this resource.');
        break;
      case 403:
        this.showMessage('Access denied. You do not have permission to access this resource.');
        break;
      case 404:
        this.showMessage('The requested resource could not be found.');
        break;
      case 409:
        this.showMessage('Conflict. The resource you are trying to access is in conflict with another resource.');
        break;
      default:
        this.showMessage('Service currently unavailable. Please try again later.');
    }
  }

  showMessage(message: string) {
    this.messageToastService.openFromComponent(
      ToastMessageComponent,
      {
        duration: 5000,
        // @ts-expect-error context is not part of the library's public config type
        context: 'error',
        data: {
          title: 'An error occurred',
          message,
        },
      },
    );
  }
}
